import { type ForwardRefExoticComponent, forwardRef } from 'react';

import { LoadingMaskContent } from './loading-mask-content';
import { LoadingMaskRoot } from './loading-mask-root';
import { LoadingMaskSpinner } from './loading-mask-spinner';
import type { LoadingMaskPropsInterface } from './types/loading-mask.types';

export const LoadingMask = forwardRef<HTMLDivElement, LoadingMaskPropsInterface>(
  (props: LoadingMaskPropsInterface, forwardedRef) => {
    const { children, ...rest } = props;

    return (
      <LoadingMaskRoot
        data-c11n-component="LoadingMask"
        data-c11n-version={__C11N_VERSION__}
        ref={forwardedRef}
        {...rest}
      >
        <LoadingMaskContent>{children}</LoadingMaskContent>
        <LoadingMaskSpinner />
      </LoadingMaskRoot>
    );
  },
) as ForwardRefExoticComponent<LoadingMaskPropsInterface> & {
  Root: typeof LoadingMaskRoot;
  Content: typeof LoadingMaskContent;
  Spinner: typeof LoadingMaskSpinner;
};

LoadingMask.displayName = 'LoadingMask';

LoadingMask.Root = LoadingMaskRoot;
LoadingMask.Content = LoadingMaskContent;
LoadingMask.Spinner = LoadingMaskSpinner;
